import { Select } from '@insta-club/ui';
import { getJalaaliWeekDayWithAddDay, getJalaaliWithAddDay } from '@insta-club/utilities';
import { useMemo } from 'react';

const START_DATE_OPTIONS = [
    {
        value: 1,
        dayOffset: 3,
        description: '( 2روز آماده‌سازی برنامه + 1 روز آماده‌سازی محتوا )'
    },
    {
        value: 2,
        dayOffset: 4,
        description: '( 2روز آماده‌سازی برنامه +2 روز آماده‌سازی محتوا )'
    },
    {
        value: 3,
        dayOffset: 5,
        description: '( 2روز آماده‌سازی برنامه +3 روز آماده‌سازی محتوا )'
    }
];

const POST_TIME_OPTIONS = [
    {
        value: 'morning',
        label: 'از ساعت 10:00 الی 11:30'
    },
    {
        value: 'noon',
        label: 'از ساعت 12:00 الی 14:00'
    },
    {
        value: 'evening',
        label: 'از ساعت 15:00 الی 18:00'
    },
    {
        value: 'night',
        label: 'از ساعت 19:30 الی 22:30'
    },
    {
        value: 'new_page',
        label: 'پیج جدید ساختم ( بدون پست و محتوا )'
    }
];

function AddPageFormStep4() {
    const startDateOptions = useMemo(
        () =>
            START_DATE_OPTIONS.map((option) => ({
                value: option.value,
                label: `${getJalaaliWeekDayWithAddDay(option.dayOffset)} ${getJalaaliWithAddDay(option.dayOffset)}`,
                description: option.description
            })),
        []
    );

    return (
        <div className='space-y-6'>
            <Select
                name='start_after_days'
                label='تاریخ شروع برنامه'
                options={startDateOptions}
                placeholder='انتخاب کنید'
            />

            <div>
                <p className='mb-4 text-[15px] font-normal text-gray-500'>
                    در کدام بازه زمانی بهترین بازخورد رو از پیجت داشتی؟
                </p>
                <Select
                    name='best_post_time'
                    label='انتخاب بازه زمانی'
                    options={POST_TIME_OPTIONS}
                    placeholder='انتخاب کنید'
                />
            </div>
        </div>
    );
}

export default AddPageFormStep4;

